export default __webpack_public_path__ + "a08b113cd567eefe69f17e5b56852a2f.png";